export class HttpError extends Error {
  public errors?: Record<string, string>;
  public message: string;
  public statusCode: number;

  constructor(props: {
    statusCode: number; message: string; errors?: Record<string, string>;
  }) {
    super(props.message);
    this.name = "HttpError";
    this.statusCode = props.statusCode;
    this.message = props.message;
    this.errors = props.errors;

    // Ensures that instances of HttpError have the correct prototype chain in environments that don't support native ES6 classes.
    Object.setPrototypeOf(this, HttpError.prototype);
  }
}
